import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editOrderErrorTitle: {
    description: 'orderEpics.editOrderErrorTitle',
    defaultMessage: 'Edit Order Error',
    id: 'b8IV9V',
  },
  editOrderErrorMessage: {
    description: 'orderEpics.editOrderErrorMessage',
    defaultMessage: 'The changes to this order could not be saved at this time. Please try again.',
    id: 'EDtfyp',
  },
  createOrderErrorTitle: {
    description: 'orderEpics.createOrderErrorTitle',
    defaultMessage: 'New Order Error',
    id: '2klo9o',
  },
  createOrderErrorMessage: {
    description: 'orderEpics.createOrderErrorMessage',
    defaultMessage: 'This order could not be created at this time. Please try again.',
    id: '8ru9Fc',
  },
  addTagsToOrderErrorTitle: {
    description: 'orderEpics.addTagsToOrderErrorTitle',
    defaultMessage: 'Tag Error',
    id: 'VX2zmc',
  },
  addTagsToOrderErrorMessage: {
    description: 'orderEpics.addTagsToOrderErrorMessage',
    defaultMessage: 'Tags could not be changed at this time. Please try again.',
    id: 'dX6aMO',
  },
  setHoldUntilErrorTitle: {
    description: 'orderEpics.setHoldUntilErrorTitle',
    defaultMessage: 'Hold Error',
    id: 'Esp9gi',
  },
  setHoldUntilErrorMessage: {
    description: 'orderEpics.setHoldUntilErrorMessage',
    defaultMessage: 'Could not set hold for orders at this time. Please try again.',
    id: '2fD3Bo',
  },
  setMarkPaidTitle: {
    description: 'orderEpics.setMarkPaidTitle',
    defaultMessage: 'Mark Paid Status',
    id: 'LxdULo',
  },
  setMarkPaidSuccessNotification: {
    description: 'orderEpics.setMarkPaidSuccessNotification',
    defaultMessage: 'Successfully marked as paid',
    id: 'LXqPys',
  },
  setMarkPaidErrorNotification: {
    description: 'orderEpics.setMarkPaidErrorNotification',
    defaultMessage: 'Failed to mark as paid',
    id: 'Z/Bbzn',
  },
  bulkCancelShipmentTitle: {
    description: 'orderEpics.bulkCancelShipmentTitle',
    defaultMessage: 'Cancel',
    id: 'WtUpSa',
  },
  bulkCancelShipmentProcessingMessage: {
    description: 'orderEpics.bulkCancelShipmentProcessingMessage',
    defaultMessage: 'Cancelling Shipments...',
    id: 'oPqL4B',
  },
  bulkCancelShipmentSuccessMessage: {
    description: 'orderEpics.bulkCancelShipmentSuccessMessage',
    defaultMessage: 'Successfully cancelled {shipmentsCancelled, plural, one {# shipment} other {# shipments}}',
    id: 'lLkp82',
  },
  bulkCancelShipmentErrorMessage: {
    description: 'orderEpics.bulkCancelShipmentErrorMessage',
    defaultMessage: 'Could not cancel shipments at this time. Please try again.',
    id: '5nSZ/3',
  },
  bulkCancelShipmentFailureMessage: {
    description: 'orderEpics.bulkCancelShipmentFailureMessage',
    defaultMessage: 'Failed to cancel {shipmentsFailedToCancel, plural, one {# shipment} other {# shipments}}. Please try again.',
    id: 'aU7vRC',
  },
  countsErrorTitle: {
    description: 'orderEpics.countsErrorTitle',
    defaultMessage: 'Search Counts',
    id: 'mT3hDG',
  },
  countsErrorMessage: {
    description: 'orderEpics.countsErrorMessage',
    defaultMessage: 'Something went wrong loading search counts.',
    id: 'oapv9h',
  },
  getRateFailureTitle: {
    description: 'orderGridNotifications.getRateFailureTitle',
    defaultMessage: 'Get Rate Error',
    id: 'OYYCAO',
  },
  getMappingsErrorTitle: {
    description: 'getMappings.getMappingsErrorTitle',
    defaultMessage: 'Mapping Error',
    id: 'iMTL1b',
  },
  getMappingsErrorMessage: {
    description: 'getMappings.getMappingsErrorMessage',
    defaultMessage: 'Could not retrieve saved mappings',
    id: 'NXkINS',
  },
  importNotificationTitle: {
    description: 'getMappings.importNotificationTitle',
    defaultMessage: 'Orders Importing',
    id: '2h1a4A',
  },
  importSuccessNotificationTitle: {
    description: 'notification confirming CSV import succeeded',
    defaultMessage: 'CSV Import Successful',
    id: 'pETeM6',
  },
  importNotificationBody: {
    description: 'getMappings.importNotificationBody',
    defaultMessage: 'Importing Orders',
    id: 'U9tal4',
  },
  orderCountsErrorTitle: {
    description: 'orderNavEpics.countsErrorTitle',
    defaultMessage: 'Order Counts',
    id: 'Cg48BY',
  },
  orderCountsErrorMessage: {
    description: 'orderNavEpics.countsErrorMessage',
    defaultMessage: 'Something went wrong loading your order counts.',
    id: 'G2+mOc',
  },
  addressValidationFailureTitle: {
    description: 'orderDetailsEpics.addressValidationFailureTitle',
    defaultMessage: 'Address Validation Error',
    id: '6IdvRg',
  },
  addressValidationFailureMessage: {
    description: 'orderDetailsEpics.addressValidationFailureMessage',
    defaultMessage: 'This address cannot be validated at this time. Please try again.',
    id: 'rOr+av',
  },
  orderErrors: {
    description: 'Order reassignment error growler title',
    defaultMessage: 'Order Errors',
    id: 'ZZepP0',
  },
  orderAssignmentErrorTitle: {
    description: 'Order reassignment error growler description',
    defaultMessage: 'Orders currently in a batch cannot be reassigned. Remove the orders from the batch and try again.',
    id: 'UCfily',
  },
  orderGridFilterOrderFailureTitle: {
    description: 'orderGrid.filterErrorTitle',
    defaultMessage: 'Unable to load orders',
    id: 'vs+ZNF',
  },
  orderGridFilterOrderFailureMessage: {
    description: 'orderGrid.filterErrorMessage',
    defaultMessage: 'Please clear any filters and reload the browser page to try again.',
    id: 'mMzxSH',
  },
  csvImportBlockedErrorTitle: {
    description: 'title displayed on the error modal when the user is blocked from importing a CSV file',
    defaultMessage: 'Upload Error',
    id: 'S1Fknt',
  },
  csvImportBlockedErrorMessage: {
    description: 'text displayed on the error modal when the user is blocked from importing a CSV file',
    defaultMessage: 'Please contact support to enable CSV order import.',
    id: 'hv63IM',
  },
  csvImportBlockedWithAccountManagerMessage: {
    description: 'When an import is blocked and the user has an account manager, this message is displayed',
    defaultMessage: 'Please contact your Account Manager,{br}<b>{name}</b> at <b>{phone}</b> or <b>{email}</b> to enable CSV order imports',
    id: 'TgMNal',
  },
});
